import { LearningModule } from '../amorg-common';
import { apiPath } from "./adminClientApi";
import { queryAuthWrapper } from "./serverApiHelpers";

const learningPath = `${apiPath}/learning`;

export const getLearningModules = async (): Promise<LearningModule[]> =>
{
    const result: LearningModule[] = await queryAuthWrapper(`${learningPath}`);
    return result;
};

export const getLearningModulesPublic = async (): Promise<LearningModule[]> =>
{
    const result: LearningModule[] = await queryAuthWrapper(`${learningPath}/public`);
    return result;
};